module.exports = __webpack_public_path__ + "static/media/kredyt_1.ee3709e0.png";